import type { Username } from 'features/user/types/username'

type UsernameSlice = {
  firstName: null | string
  lastName: null | string
}

export const composeUsername = ({ firstName, lastName }: UsernameSlice): Username => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`
  } else if (firstName) {
    return firstName
  } else if (lastName) {
    return lastName
  } else {
    return undefined
  }
}
